'use client'

import { useState, useEffect } from 'react'

const INTRO_STORAGE_KEY = 'social-circle-intro-seen'

export function useIntroState() {
  // Initialize with a function to check localStorage synchronously on first render
  const [hasSeenIntro, setHasSeenIntro] = useState<boolean>(() => {
    if (typeof window === 'undefined') return true // SSR fallback - skip intro
    try {
      const introSeen = localStorage.getItem(INTRO_STORAGE_KEY)
      return introSeen === 'true'
    } catch (error) {
      console.error('Error accessing localStorage:', error)
      return true // Default to true (skip intro) to show content immediately
    }
  })
  const [isLoading, setIsLoading] = useState(false) // No loading needed

  // Remove the useEffect since we're doing synchronous initialization

  const markIntroAsSeen = () => {
    try {
      localStorage.setItem(INTRO_STORAGE_KEY, 'true')
      setHasSeenIntro(true)
    } catch (error) {
      console.error('Error setting localStorage:', error)
    }
  }

  const resetIntro = () => {
    try {
      localStorage.removeItem(INTRO_STORAGE_KEY)
      setHasSeenIntro(false)
    } catch (error) {
      console.error('Error removing from localStorage:', error)
    }
  }

  return {
    hasSeenIntro,
    isLoading,
    markIntroAsSeen,
    resetIntro,
  }
}
